import type { MouseEventHandler } from 'react'
import React, { useContext, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import CarHireItemSummaryLocationModal from 'components/Common/OrderView/OrderItemSummaries/CarHireItemSummary/CarHireItemSummaryLocationModal'

interface Props {
  sameLocation: boolean
  pickUpLocationName: string
  dropOffLocationName: string
  order: App.Order
}

export default function CarHirePurchaseSummaryLocation(props: Props) {
  const { sameLocation, pickUpLocationName, dropOffLocationName, order } = props

  const showModal = useContext(ModalContext)

  const onLocationModalClick = useCallback<MouseEventHandler<HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    const openTab = event.currentTarget.dataset.tab as ('Pick-up' | 'Drop-off')
    showModal(<CarHireItemSummaryLocationModal orderItem={order.carHireItems[0]} openTab={openTab} />)
  }, [order.carHireItems, showModal])

  return (
    <>
      {sameLocation && <FormattedMessage
        id="8Mw2Yh+nXF"
        defaultMessage="Pick-up & Drop-off at {locationLink}"
        description="Car hire pick-up and drop-off location when both are the same"
        values={{
          locationLink: <TextLink onClick={onLocationModalClick}>{pickUpLocationName}</TextLink>,
        }}
      />}
      {!sameLocation && <>
        <FormattedMessage
          id="YawWu47sPu"
          defaultMessage="Pick up at {locationLink}"
          description="Car hire pick-up location"
          values={{
            locationLink: <TextLink data-tab="Pick-up" onClick={onLocationModalClick}>{pickUpLocationName}</TextLink>,
          }}
        />
        <div>
          <FormattedMessage
            id="NYfVeKbGsq"
            defaultMessage="Drop-off at {locationLink}"
            description="Car hire drop-off location"
            values={{
              locationLink: <TextLink data-tab="Drop-off" onClick={onLocationModalClick}>{dropOffLocationName}</TextLink>,
            }}
          />
        </div>
      </>}
    </>
  )
}
